import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PoHeaderSearchParams } from 'src/app/core/models/transport-operation/po-header-search-params';
import { LaasCalenderComponent } from 'src/app/features/setting/pages/laas-calender/laas-calender.component';
import { DataTableComponent } from 'src/app/shared/components/data-table/data-table.component';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { PoServiceService } from '../../services/po-service.service';

@Component({
  selector: 'laas-po-search',
  templateUrl: './po-search.component.html',
  styleUrls: ['./po-search.component.scss'],
})
export class PoSearchComponent extends SessionBaseComponent implements OnInit {
  readonly viewPermissionCode = PermissionConstants.ViewSearchPurchaseOrder;
  @ViewChild('createDt') createDt!: LaasCalenderComponent;
  @ViewChild('PoHeader') PoHeader!: DataTableComponent;
  isSearchFormOpen: boolean = true;
  isPoTableOpen: boolean = false;
  isHeaderLoading: boolean = false;
  isDetailLoading: boolean = false;
  selectionMode: string = 'single';
  currentLang: string = this.laasSetting.language;

  poHeaderColumns: any[];
  poDetailColumns: any[];
  searchForm: FormGroup;
  searchHeaderParams: PoHeaderSearchParams;

  headerResults: any[] = [];
  detailResults: any[] = [];

  constructor(
    injector: Injector,
    private formBuilder: FormBuilder,
    private poServiceService: PoServiceService
  ) {
    super(injector);

    this.searchForm = this.formBuilder.group({
      warehouse: null,
      poNos: [],
      asnNos: [],
      dnNos: [],
      createDtStart: null,
      createDtEnd: null,
    });

    this.searchHeaderParams = {
      warehouse: '',
      poNos: [],
      asnNos: [],
      dnNos: [],
      createDtStart: null,
      createDtEnd: null,
    };

    this.poHeaderColumns = [
      { field: 'poNo', header: 'PurchaseOrder.HeaderColumn.PoNo', sort: true },
      {
        field: 'warehouse',
        header: 'PurchaseOrder.HeaderColumn.Plant',
        sort: true,
      },
      {
        field: 'poType',
        header: 'PurchaseOrder.HeaderColumn.Type',
        sort: true,
      },
      {
        field: 'vendorNo',
        header: 'PurchaseOrder.HeaderColumn.VendorNo',
        sort: true,
      },
      {
        field: 'vendorName',
        header: 'PurchaseOrder.HeaderColumn.VendorName',
        sort: true,
      },
      {
        field: 'onlyAsnFlag',
        header: 'PurchaseOrder.HeaderColumn.OnlyAsnFlag',
        sort: true,
      },
      {
        field: 'createUser',
        header: 'PurchaseOrder.HeaderColumn.CreateUser',
        sort: true,
      },
      {
        field: 'createDt',
        header: 'PurchaseOrder.HeaderColumn.CreateDt',
        sort: true,
      },
    ];

    this.poDetailColumns = [
      { field: 'poNo', header: 'PurchaseOrder.DetailColumn.PoNo', sort: true },
      {
        field: 'poLineNumber',
        header: 'PurchaseOrder.DetailColumn.PoLineNumber',
        sort: true,
      },
      {
        field: 'openQty',
        header: 'PurchaseOrder.DetailColumn.OpenQty',
        sort: true,
      },
      { field: 'sku', header: 'PurchaseOrder.DetailColumn.Sku', sort: true },
      {
        field: 'manufacturerPartNumber',
        header: 'PurchaseOrder.DetailColumn.ManufacturerPartNumber',
        sort: true,
      },
      {
        field: 'brand',
        header: 'PurchaseOrder.DetailColumn.Brand',
        sort: true,
      },
      {
        field: 'location',
        header: 'PurchaseOrder.DetailColumn.Location',
        sort: true,
      },
      {
        field: 'createUser',
        header: 'PurchaseOrder.DetailColumn.CreateUser',
        sort: true,
      },
      {
        field: 'createDt',
        header: 'PurchaseOrder.DetailColumn.CreateDt',
        sort: true,
      },
    ];
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

  }

  searchBtnClick() {
    this.isHeaderLoading = true;
    this.isSearchFormOpen = false;
    this.searchHeaderParams = this.searchForm.value;
    this.poServiceService.searchPoHeader(this.searchHeaderParams).subscribe({
      next: (results: any[]) => {
        this.headerResults = results;
        this.detailResults = [];
      },
      complete: () => {
        this.isHeaderLoading = false;
      },
    });
  }

  searchDetail(event: any) {
    this.isDetailLoading = true;
    this.poServiceService.searchPoDetailByPoNo(event.poNo).subscribe({
      next: (results: any[]) => {
        this.detailResults = results;
      },
      complete: () => {
        this.isDetailLoading = false;
      },
    });
  }

  editPo(event: any, rowdata: any) {
    this.routeStateService.navigateTo(
      '/TransportOperation/PoConvertAd',
      { poHeader: rowdata },
      true
    );
  }

  resetBtnClick() {
    this.searchForm.reset();
    this.createDt.ngOnInit();
    this.searchHeaderParams.createDtStart = null;
    this.searchHeaderParams.createDtEnd = null;
  }

  dateOnChange(date: any, type: string) {
    switch (type) {
      case 'createDt':
        this.searchForm.controls.createDtStart.setValue(date.startDate);
        this.searchForm.controls.createDtEnd.setValue(date.endDate);
        break;
    }
  }
}
